import { axiosConfig } from '../api/axios-config.js'

// Line 群組
export const lineGroup = {
  // 取得群組清單
  get: (params, token) => axiosConfig.get('/api/line-groups', token, params),

  // 取得單一群組
  getOne: (id, token) => axiosConfig.get(`/api/line-groups/${id}`, token),

  // 更新群組
  update: (id, data, token) => axiosConfig.put(`/api/line-groups/${id}`, data, token),

  // 刪除群組
  delete: (id, token) => axiosConfig.delete(`/api/line-groups/${id}`, token)
}